export function compose(...params) {
  return params.reduce((acc, x) => Object.assign(acc, x), {});
}
